/**
 * How long the kiosk waits before its next attempt to reopen the live status socket [03-us-kad-6j-b AC-3;
 * decision 0354 § 5].
 *
 * ⭐ **Exponential from 1 s to 30 s, with FULL jitter** — the ceiling doubles with every failed attempt
 * (1 s, 2 s, 4 s, 8 s, 16 s, then 30 s and no higher) and the wait is drawn uniformly from zero up to that
 * ceiling. "Full" is the approved plan's word (0354 § 5, Plan L33), and it is the variant that matters here:
 * every tablet behind a branch address loses the gateway in the same instant, and a jitter that only
 * nudged a fixed schedule would bring them all back in the same instant too.
 *
 * ⛔ **No fixed interval and no minimum.** A floor under the draw would be a fixed period by another name.
 */
export const RECONNECT_BASE_MS = 1_000;
export const RECONNECT_CAP_MS = 30_000;

/**
 * The wait before attempt `attempt + 1`, where `attempt` counts the attempts that have failed since the
 * socket was last open. `random` is injectable so the shape can be pinned by a test.
 */
export function reconnectDelayMs(attempt: number, random: () => number = Math.random): number {
  // `2 ** attempt` overflows to Infinity long after the cap applies, and `Math.min` absorbs it.
  const ceiling = Math.min(RECONNECT_CAP_MS, RECONNECT_BASE_MS * 2 ** attempt);
  return Math.floor(random() * ceiling);
}
